import { Post } from "../../models/Post";
import { PrimaryInfo } from "../util";

export const getSuggestion = (post: Post): PrimaryInfo => {
    return {
        name: post.subject,
        id: post.id
    };
};
